// Application constants

// WhatsApp Group Link
// Format: https://chat.whatsapp.com/[GROUP_INVITE_CODE] or https://wa.me/[PHONE_NUMBER]
// Replace with your actual WhatsApp group invite link
export const WHATSAPP_GROUP_LINK = 'https://chat.whatsapp.com/HlJyxU8ACnk6U4Qy4ztiE4';

